import ApiClient from "@/libs/http-client";

// Psychologist's video room (host side needs auth, guest side works by link)
const RoomServices = {
  hostShow() {
    return ApiClient.get("api/psychologists/me/room");
  },
  hostOpen() {
    return ApiClient.post("api/psychologists/me/room/open");
  },
  hostClose() {
    return ApiClient.post("api/psychologists/me/room/close");
  },
  hostRegenerate() {
    return ApiClient.post("api/psychologists/me/room/regenerate");
  },
  hostKick() {
    return ApiClient.post("api/psychologists/me/room/kick");
  },
  hostSignal(guestId, payload) {
    return ApiClient.post("api/psychologists/me/room/signal", {
      guest_id: guestId,
      payload: JSON.stringify(payload),
    });
  },
  hostPoll(after) {
    return ApiClient.get(`api/psychologists/me/room/poll?after=${after}`);
  },

  guestShow(token) {
    return ApiClient.get(`api/rooms/${token}`);
  },
  guestJoin(token, guestId, guestName, fresh) {
    return ApiClient.post(`api/rooms/${token}/join`, {
      guest_id: guestId,
      guest_name: guestName || null,
      fresh: !!fresh,
    });
  },
  guestSignal(token, guestId, payload) {
    return ApiClient.post(`api/rooms/${token}/signal`, {
      guest_id: guestId,
      payload: JSON.stringify(payload),
    });
  },
  guestPoll(token, guestId, after) {
    return ApiClient.get(
      `api/rooms/${token}/poll?guest_id=${guestId}&after=${after}`
    );
  },
  guestLeave(token, guestId) {
    return ApiClient.post(`api/rooms/${token}/leave`, { guest_id: guestId });
  },

  myStats(days = 30) {
    return ApiClient.get(`api/psychologists/me/stats?days=${days}`);
  },
};

export default RoomServices;
